export default __webpack_public_path__ + "static/media/SLO.61825d98.svg";